import React from 'react';
import './_main.css';
import {Link, Outlet, useNavigate} from 'react-router-dom';
import IconsM3 from '../../components/Icons/IconsM3';

const Layout = () => {    
    const navigate = useNavigate();

    function Logout(){
        localStorage.removeItem("supportTok");
        navigate("/");         
    } 

    const handlewrapperClick = () => {
        let wrapperelement = document.getElementById("wrapper")!
        let elementmenu = document.getElementById("layout-menu")!        
        wrapperelement.classList.remove("active")   
        elementmenu.classList.remove("display-nav")     
    }

    const handleClick = () => {    
        let element = document.getElementById("layout-menu")!
        let wrapperelement = document.getElementById("wrapper")!
        element.classList.add("display-nav")    
        wrapperelement.classList.add("active")
    };
    

    function Goto(ruta:string){        
        handlewrapperClick()
        navigate(ruta);                                 
    }

    return (                    
        <div className='content-master'>            
            <header className='header-mainbar'>                
                <div className='img-menu' onClick={handleClick}>                    
                    <IconsM3 iconname='menu'/>
                </div>
            
                <div className='header-logomain ml-10'>                                                    
                    <img  className='img-logomain' src="https://helpdeskmakos.com/img/yellow/favicon192.png"  alt="MaKOS"/>                    
                </div>

                <aside id="layout-menu" className="menu-horizontal">
                    <div className='img-menu-open' onClick={handlewrapperClick}>                        
                        <IconsM3 iconname='menuopen'/>                        
                    </div>
                    <div className="container-menu d-flex">                                                            
                        <div className="menu-horizontal-wrapper">
                            <ul className="menu-inner">                           
                                <li className="menu-item">
                                    <a href="#" className="menu-link" onClick={(e) => Goto("main")}>                                                
                                        <IconsM3 iconname='homeanalitycs'/>
                                        <div data-i18n="Dashboards">Dashboard</div>
                                    </a>                                    
                                </li>                                

                                <li className="menu-item">
                                    <a href="#" className="menu-link" onClick={(e) => Goto("Tickets")}>
                                        <IconsM3 iconname='invoice'/>
                                        <div data-i18n="Layouts">Tickets</div>
                                    </a>                                    
                                </li>

                                <li className="menu-item">
                                    <a href="#" className="menu-link" onClick={(e) => Goto("Tickets")}>
                                        <IconsM3 iconname='tutorial'/>
                                        <div data-i18n="Layouts">Manuales</div>
                                    </a>                                    
                                </li>

                                <li className="menu-item">
                                    <a href="#" className="menu-link" onClick={(e) => Goto("Tickets")}>
                                        <IconsM3 iconname='supportagent'/>
                                        <div data-i18n="Layouts">Soluciones</div>
                                    </a>                                    
                                </li>
                                
                                <li className="menu-item">
                                    <a href="#" className="menu-link" onClick={(e) => Logout()}>
                                        <IconsM3 iconname='logout'/>
                                        <div data-i18n="Layouts">Salir</div>
                                    </a>
                                </li>                                                            
                            </ul>
                        </div>                                
                    </div>
                </aside>                  
            </header>   
            <div id="wrapper"  onClick={handlewrapperClick}></div>         
            <main id="lytOutlet" className='outlet'>
                <Outlet />
            </main>                      
            <div id="main"></div>            
        </div>   
        
    );
  }

export default Layout;